import type { FC } from 'react'
import styled from '@emotion/styled'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import * as CopyText from '@segment/matcha/recipes/CopyText'

import Autocomplete from '../Autocomplete'

const copy = {
  heading: `What are you having trouble with?`,
  description: `Browse our resources, search the knowledge base, or submit a ticket to our support team.`,
}

interface HeroProps {
  query: string
  onQueryChange: (newQuery: string) => void
}

const Hero: FC<HeroProps> = () => {
  return (
    <Wrapper>
      <StyledHeroBase variant="centered">
        <StyledHeroCopy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="h2" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </StyledHeroCopy>
        <StyledHeroContents>
          <Autocomplete name="help_page_query" />
        </StyledHeroContents>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-bottom: 80px;
    }
  }
`

const StyledHeroCopy = styled(HeroRecipe.Copy)`
  max-width: 600px;
`

const StyledHeroContents = styled(HeroRecipe.Contents)`
  max-width: 520px;
`

export default Hero
